import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { alertColor } from "../styled/variable";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import {
  Divider,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import ConfirmModal from "../confirmModal/ConfirmModal";
import { useTranslation } from "react-i18next";

function MemberRowRoleDD(props) {
  const { t } = useTranslation(["workspace"]);
  const { roles, authenticateUser } = props;

  const [ddIcon, setDDIcon] = useState("down");

  const [member, setMember] = useState(props.member);
  const [memberRole, setMemberRole] = useState(
    member?.content_role ? member.content_role : member.role
  );
  const [isAuthenticatedUser, setAuthenticatedUser] = useState(
    member?.user_id === authenticateUser.pk
  );
  const [isAuthorizeToChangeRole, setAuthorizeToChangeRole] = useState(
    props.isAuthorizeToChangeRole
  );
  const [confirmation, setConfirmation] = useState(false);
  const [confirmationLeave, setConfirmationLeave] = useState(false);

  useEffect(() => {
    setMember({ ...props.member });
    setMemberRole(
      props.member?.content_role ? props.member.content_role : props.member.role
    );
  }, [props.member]);

  useEffect(() => {
    setAuthenticatedUser(props.authenticateUser.pk === member?.user_id);
  }, [member, props.authenticateUser.pk]);

  useEffect(() => {
    setAuthorizeToChangeRole(props.isAuthorizeToChangeRole);
  }, [props.isAuthorizeToChangeRole]);

  function onDDToggle() {
    if (ddIcon === "down") {
      setDDIcon("up");
    } else {
      setDDIcon("down");
    }
  }

  return (
    <>
      {!isAuthorizeToChangeRole ? (
        <>
          {isAuthenticatedUser ? (
            <Menu isLazy>
              <MenuButton
                bg="transparent"
                border="none"
                onClick={onDDToggle}
                sx={{
                  span: {
                    color: "gray.100",
                  },
                }}
              >
                {!member.is_active
                  ? t("member_row_menu.pending")
                  : member?.shared_content
                  ? `${member?.shared_content} Page`
                  : memberRole?.display_name || memberRole?.name}
                {ddIcon === "up" ? (
                  <Icon as={FaAngleUp} ml={2} />
                ) : (
                  <Icon as={FaAngleDown} ml={2} />
                )}
              </MenuButton>
              <MenuList>
                <MenuItem
                  onClick={() => setConfirmationLeave(true)}
                  color={alertColor}
                  _hover={{
                    color: alertColor,
                  }}
                >
                  {t("member_row_menu.leave")}
                </MenuItem>
              </MenuList>
            </Menu>
          ) : (
            <Text>
              {!member.is_active
                ? t("member_row_menu.pending")
                : member?.shared_content
                ? `${member?.shared_content} Page`
                : memberRole?.display_name || memberRole?.name}
            </Text>
          )}
        </>
      ) : (
        <Menu isLazy>
          <MenuButton
            bg="transparent"
            border="none"
            onClick={onDDToggle}
            sx={{
              span: {
                color: "gray.100",
              },
            }}
          >
            {!member.is_active
              ? t("member_row_menu.pending")
              : member?.shared_content
              ? t("member_row_menu.page", {
                  shared_content: member?.shared_content,
                })
              : memberRole?.display_name || memberRole?.name}
            {ddIcon === "up" ? (
              <Icon as={FaAngleUp} ml={2} />
            ) : (
              <Icon as={FaAngleDown} ml={2} />
            )}
          </MenuButton>
          <MenuList>
            {!isAuthenticatedUser && (
              <>
                {roles &&
                  roles.map((role, index) => {
                    if (role.id === memberRole?.id) {
                      return <React.Fragment key={role.id}></React.Fragment>;
                    }
                    return (
                      <MenuItem
                        key={role.id}
                        onClick={(event) =>
                          props.onAction("changeRole", { role, member })
                        }
                      >
                        {t("member_row_menu.make_role", {
                          display_name: role?.display_name || role?.name,
                        })}
                      </MenuItem>
                    );
                  })}
                <Divider color="gray.300" my="1" />
              </>
            )}
            {!member.is_active && (
              <MenuItem
                onClick={(event) =>
                  props.onAction("remind", { role: memberRole, member })
                }
              >
                {t("member_row_menu.remind")}
              </MenuItem>
            )}
            {isAuthenticatedUser ? (
              <MenuItem
                onClick={(event) => setConfirmationLeave(true)}
                color={alertColor}
                _hover={{
                  color: alertColor,
                }}
              >
                {t("member_row_menu.leave")}
              </MenuItem>
            ) : (
              <MenuItem
                onClick={(event) => setConfirmation(true)}
                color={alertColor}
                _hover={{
                  color: alertColor,
                }}
              >
                {t("member_row_menu.remove")}
              </MenuItem>
            )}
          </MenuList>
          {confirmation && (
            <ConfirmModal
              isOpen
              title={t("member_row_modal.title")}
              message={t("member_row_modal.message")}
              onConfirm={() =>
                props.onAction("remove", { role: memberRole, member })
              }
              onClose={() => setConfirmation(false)}
              cancelButtonText={t("member_row_modal.cancel_btn_text")}
              confirmButtonText={t("member_row_modal.confirm_btn_text")}
            />
          )}
        </Menu>
      )}
      {confirmationLeave && (
        <ConfirmModal
          isOpen
          title={t("member_row_modal.leave_title")}
          message={t("member_row_modal.leave_message")}
          onConfirm={() => {
            props.onAction("leave", { role: memberRole, member });
            setConfirmationLeave(false);
          }}
          onClose={() => setConfirmationLeave(false)}
          cancelButtonText={t("member_row_modal.cancel_btn_text")}
          confirmButtonText={t("member_row_modal.leave_confirm_btn")}
        />
      )}
    </>
  );
}

MemberRowRoleDD.propTypes = {};

const mapStateToProps = (state) => ({
  authenticateUser: state.auth.payload.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MemberRowRoleDD);
